import type { Layer } from '../core/model';
import type { EditableText } from '../vector/types';
export const PORTABLE_TEXT_FEATURE = 'portable-text-layout-v1';
export type { PortableTextLayoutPayload as NativePortableTextPayload } from './portable-text-contract';
import { validatePortableTextLayout } from './portable-text-contract';

export function validateNativePortableText(text: EditableText): void {
  if (text.schemaVersion === 1) {
    if (text.portable !== undefined) throw new Error('Portable text requires text payload schema 2.');
    return;
  }
  if (text.schemaVersion !== 2) throw new Error('Unsupported text payload version.');
  validatePortableTextLayout(text.portable!, text);
}

export function hasNativePortableText(layer: Layer): boolean {
  return layer.kind === 'text' ? layer.text.schemaVersion === 2 : layer.kind === 'group' && layer.children.some(hasNativePortableText);
}
